import * as React from 'react';
import { DesktopRating } from '@cian/frontend-reviews-components';
import { ArticleHeading2 } from '@cian/ui-kit';
import * as style from './ReviewsTitle.css';

export interface IReviewsTitleProps {
  rating: number;
  title: string;
}

export const ReviewsTitle: React.FC<IReviewsTitleProps> = ({ rating, title }) => {
  return (
    <div className={style['container']}>
      <div className={style['title']}>
        <ArticleHeading2 as="h2">{title}</ArticleHeading2>
      </div>
      <DesktopRating value={rating} />
    </div>
  );
};
